import { render, staticRenderFns } from "./channelDetail.vue?vue&type=template&id=073f0a46"
import script from "./channelDetail.vue?vue&type=script&lang=js"
export * from "./channelDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports